

import React from 'react';

export const RefreshArrowSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "12"} height={height ?? "14"} viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6217 5.39612C11.009 6.32916 11.1178 7.38805 10.8701 8.44677C10.2412 11.134 7.55291 12.8027 4.86566 12.1738C2.1784 11.5449 0.509771 8.85662 1.13866 6.16936C1.71935 3.68809 4.0558 2.07526 6.52604 2.33767" stroke={color ?? window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="1.24929" />
      <path d="M5.37704 0.623779L7.25098 2.34156L5.37704 4.05933" stroke={color ?? window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="1.24929" strokeLinejoin="round" />
      <circle cx="0.624646" cy="0.624646" r="0.312323" transform="matrix(-1 0 0 1 6.00195 0)" fill={window?.settings?.secondary_color ?? '#04333b'} stroke={color ?? window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="0.624646" />
      <circle cx="0.624646" cy="0.624646" r="0.312323" transform="matrix(-1 0 0 1 6.00195 3.43628)" fill={window?.settings?.secondary_color ?? '#04333b'} stroke={color ?? window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="0.624646" />
      <circle cx="10.6369" cy="5.4347" r="0.312323" fill={window?.settings?.secondary_color ?? '#04333b'} stroke={color ?? window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="0.624646" />
    </svg>

  )
}
